class Pressure {
  static instances = []
  touch = null
  force = 0
  time = 0
  timeThreshold = 400
  forceThreshold = 0.5
  timerInterval = null
  contextMenuTrigger = true
  static emptyFn = () => {}

  get factor () {
    return Math.min(
      Math.max(this.force / this.forceThreshold, this.time / this.timeThreshold),
      1
    )
  }

  constructor (element, config = {}) {
    this.listen(element)
    const listeners = ['start', 'end', 'change', 'press']
    listeners.forEach(name => {
      this[name] = config[name] || Pressure.emptyFn
    })
    if (config.contextMenuTrigger === false) this.contextMenuTrigger = false
    if (config.timeThreshold != null) this.timeThreshold = config.timeThreshold
    if (config.forceThreshold != null) this.forceThreshold = config.forceThreshold
    Pressure.instances.push({ element, instance: this })
    return element
  }

  endPress (e, thisArg) {
    const instance = thisArg || this
    if (instance.factor) {
      instance.end({
        event: e,
        force: 0,
        time: instance.time,
        factor: 0,
        instance: instance
      })
    }
    clearInterval(instance.timerInterval)
    instance.touch = null
    instance.force = 0
    instance.time = 0
    instance.timerInterval = null
  }

  listen (element) {
    const instance = this
    function startListener (e) {
      instance.touch = e.changedTouches ? e.changedTouches[0] : null
      if (!instance.timerInterval) {
        instance.timerInterval = setInterval(() => instance.addTime(), 20)
      }
      instance.start({
        event: e,
        force: instance.touch ? instance.touch.force || 0 : 0,
        time: 0,
        factor: 0,
        instance: instance
      })
    }
    const endListener = (e) => instance.endPress(e, instance)
    function changeListener (e) {
      const touch = e.changedTouches ? e.changedTouches[0] : {}
      const force = touch.force || e.webkitForce / 4
      if (touch.identifier && touch.identifier !== (instance.touch || {}).identifier) return
      if (instance.force < instance.forceThreshold && force >= instance.forceThreshold) {
        e.preventDefault()
        instance.press({
          event: e,
          force: force,
          time: instance.time,
          factor: instance.factor,
          instance: instance,
          reason: 'pressure'
        })
        return endListener(e)
      }
      instance.force = force
      instance.touch = touch
      instance.change({
        event: e,
        force: force,
        time: instance.time,
        factor: instance.factor,
        instance: instance
      })
    }
    element.addEventListener('touchstart', startListener)
    element.addEventListener('touchend', endListener)
    element.addEventListener('touchmove', event => {
      const touch = event.changedTouches[0]
      const rect = element.getBoundingClientRect()
      const outsideX = touch.clientX < rect.left || touch.clientX > rect.left + rect.width
      const outsideY = touch.clientY < rect.top || touch.clientY > rect.top + rect.height
      if (outsideX || outsideY) return endListener(event)
    })
    element.addEventListener('mousedown', startListener)
    document.body.addEventListener('mouseup', endListener)
    element.addEventListener('mouseout', endListener)
    element.addEventListener('webkitmouseforcechanged', changeListener)
    element.addEventListener('touchforcechange', changeListener)
    element.addEventListener('contextmenu', e => {
      if (!instance.contextMenuTrigger) return
      e.preventDefault()
      instance.press({
        event: e,
        force: 0.5,
        time: instance.time,
        factor: instance.factor,
        instance: instance,
        reason: 'contextmenu'
      })
      endListener(e)
    })
  }

  addTime () {
    this.time += 20
    this.change({
      event: null,
      force: this.force,
      time: this.time,
      factor: this.factor,
      instance: this,
      reason: 'time'
    })
    if (this.time >= this.timeThreshold) {
      this.press({
        event: null,
        force: this.force,
        time: this.time,
        factor: this.factor,
        instance: this,
        reason: 'time'
      })
      clearInterval(this.timerInterval)
    }
  }

  static create (element, config) {
    return new Pressure(element, config)
  }

  static cancel (element, event) {
    const item = Pressure.instances.find(i => i.element === element)
    if (!item) return false
    item.instance.endPress(event, item)
  }
}

Object.assign(globalThis, { Pressure })
export { Pressure }
